import { useRouter } from 'next/router'

import HomCalendarIcon from '~/components/Icons/svgs/HomCalendarIcon'
import HomCameraCircleIcon from '~/components/Icons/svgs/HomCameraCircleIcon'
import HomChecklistIcon from '~/components/Icons/svgs/HomChecklistIcon'
import HomClassroomAltIcon from '~/components/Icons/svgs/HomClassroomAltIcon'
import HomClassroomIcon from '~/components/Icons/svgs/HomClassroomIcon'
import HomClockIcon from '~/components/Icons/svgs/HomClockIcon'
import HomGraduationCapCircleIcon from '~/components/Icons/svgs/HomGraduationCapCircleIcon'
import HomLaptopIcon from '~/components/Icons/svgs/HomLaptopIcon'
import HomPersonWithTabletIcon from '~/components/Icons/svgs/HomPersonWithTabletIcon'
import MentorChatIcon from '~/components/Icons/svgs/MentorChatIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import { IconName } from '~/components/Icons/types'
import { Link } from '~/components/Link'

export default function PanelTabItem({
  href,
  icon,
  isActive,
  isDisabled,
  label,
}: {
  href: string | { pathname: string; query: Record<string, string> }
  icon?: IconName
  isActive: boolean
  isDisabled: boolean
  label: string
}): React.ReactElement {
  const router = useRouter()

  const getIconComponent = (name: string): ((props: { [key: string]: any }) => React.ReactElement) => {
    switch (name) {
      case 'hom-graduation-cap-circle':
        return HomGraduationCapCircleIcon
      case 'hom-camera-circle':
        return HomCameraCircleIcon
      case 'hom-classroom':
        return HomClassroomIcon
      case 'hom-classroom-alt':
        return HomClassroomAltIcon
      case 'mentor-chat':
        return MentorChatIcon
      case 'hom-person-with-tablet':
        return HomPersonWithTabletIcon
      case 'hom-calendar':
        return HomCalendarIcon
      case 'hom-laptop':
        return HomLaptopIcon
      case 'hom-checklist':
        return HomChecklistIcon
      case 'hom-clock':
        return HomClockIcon
      default:
        return HomClockIcon
    }
  }

  return (
    <Link
      className={
        // `shrink-0` + `whitespace-nowrap`: inside the scrolling strip a tab keeps its natural
        // width instead of being compressed until its label wraps.
        'px-1 pb-0.5 space-x-1.5 shrink-0 flex items-center whitespace-nowrap text-xs md:text-sm ' +
        `${isActive ? 'border-b-2 border-hotpink text-hotpink' : ''} ` +
        `${isDisabled ? 'opacity-50' : ''}`
      }
      key={label}
      style={{ marginBottom: isActive ? '-2px' : '0' }}
      to={!isDisabled ? href : router.asPath}
    >
      {icon && <SVGIcon icon={getIconComponent(icon)} size={22} />}
      <span>{label}</span>
    </Link>
  )
}
